const IconClockNotification = props => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="clock">
			<path
				id="Vector"
				d="M8.00018 14.5C8.73352 14.5 9.33352 13.9 9.33352 13.1667H6.66685C6.66685 13.9 7.26685 14.5 8.00018 14.5ZM12.0002 10.5V7.16667C12.0002 5.12 10.9135 3.40667 9.00018 2.95333V2.5C9.00018 1.94667 8.55352 1.5 8.00018 1.5C7.44685 1.5 7.00018 1.94667 7.00018 2.5V2.95333C5.09352 3.40667 4.00018 5.11333 4.00018 7.16667V10.5L2.66685 11.8333V12.5H13.3335V11.8333L12.0002 10.5ZM10.6668 11.1667H5.33352V7.16667C5.33352 5.51333 6.34018 4.16667 8.00018 4.16667C9.66018 4.16667 10.6668 5.51333 10.6668 7.16667V11.1667ZM5.05352 2.55333L4.10018 1.6C2.50018 2.82 1.44685 4.7 1.35352 6.83333H2.68685C2.78685 5.06667 3.69352 3.52 5.05352 2.55333ZM13.3135 6.83333H14.6468C14.5468 4.7 13.4935 2.82 11.9002 1.6L10.9535 2.55333C12.3002 3.52 13.2135 5.06667 13.3135 6.83333Z"
				fill="currentColor"
			/>
		</g>
	</svg>
);

export default IconClockNotification;
